import * as Sentry from "@sentry/react";
import sentryConfigService, { SentryDynamicConfig } from "./services/sentry-config-service";
import packageJson from './package.json';

Sentry.init({
  dsn: "https://50fb24641cc3f7bf2bc72e6e2fc0cab5@o4510787235545088.ingest.de.sentry.io/4511256866062416", 
  sendDefaultPii: true,
  release: `ServCraftWeb@${packageJson.version}`,
  environment: process.env.NODE_ENV ?? 'development',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    ...(Sentry.consoleLoggingIntegration
      ? [Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] })]
      : []),
    ...(Sentry.featureFlagsIntegration
      ? [Sentry.featureFlagsIntegration()]
      : []),
  ],
  tracesSampler: SentryDynamicConfig.tracesSampler,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/.*\.servcraft\.co\.za\/api/,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.1,
  beforeSend: SentryDynamicConfig.beforeSend,
  beforeSendTransaction: SentryDynamicConfig.beforeSendTransaction,
  _experiments: {
    enableLogs: true,
    beforeSendLog: (log: any) => {
      if (!sentryConfigService.isEnabled()) return null;
      return log;
    },
  },
});
